import React, { useState, useHook, useEffect, useRef } from "react";
import Header from "../Header";
import SideBar from "../SideBar";
import Footer from "../Footer";
import Loader from "../Loader";
import { get, post, put, deleteM } from "../../utility/Adapter";
import { withParams } from "../HOC";

import { info, success, error } from "@pnotify/core";
import "@pnotify/core/dist/PNotify.css";
import "@pnotify/core/dist/BrightTheme.css";
import * as Confirm from "@pnotify/confirm";
import "@pnotify/confirm/dist/PNotifyConfirm.css";
import DataTable, { createTheme } from "react-data-table-component";
import Cookies from "js-cookie";
import {
  Stethoscope,
  UserRound,
  ClipboardCheck,
  GraduationCap,
  XCircle,
  Clipboard,
} from "lucide-react";
import Toast from "../../components/Toast";
import axios from "axios";

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const HcDocuments = (props) => {

    const [loading, setLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [documentsOther, setDocumentsOther] = useState([]);
    const [documentId, setDocumentId] = useState(0);
    const [profile, setProfile] = useState({
        "candidate_first_name": "",
        "candidate_last_name": "",
        "candidate_email": "",
        "candidate_phone": "",
        "candidate_degree": "",
        "candidate_licence": "",
        "candidate_status": 0,
        "candidate_dob": "",
        "candidate_language_level": "",
        "id": 0,
        "candidate_id": "",
        "document_status": 0,
        "created": ""
    });

    const documentName = useRef(null);
    const documentFile = useRef(null);

    const documentNameOther = useRef(null);
    const documentFileOther = useRef(null);

    const getData = () => {
        try {
            const value = Cookies.get('hcAdmin')
            if (value !== undefined) {
                return value;
            }
        } catch (e) {
            // error reading value
        }
    }

    useEffect(() => {
        _loadDocuments('signed');
        _loadDocuments('other');
    }, []);

    const _loadDocuments = (type) => {
        if (type === 'signed') {
            setDocuments([]);
        } else {
            setDocumentsOther([]);
        }
        setLoading(true);
        get("admin/hc_documents/" + props.params.id + '/' + type)
            .then(async function (response) {
                setLoading(false);
                if (type === 'signed') {
                    setDocuments(response.data.data);
                    setProfile(response.data.profile);
                }
                else {
                    setDocumentsOther(response.data.data);
                }
            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    }

    const uploadDocumentOther = () => {
        if (!documentNameOther.current.value) {
            error({
                title: "ERROR",
                text: "Document Name is required",
                modules: new Map([
                    [
                        Confirm,
                        {
                            confirm: true,
                            buttons: [
                                {
                                    text: "Ok",
                                    primary: true,
                                    click: (notice) => {
                                        notice.close();
                                    },
                                },
                            ],
                        },
                    ],
                ]),
            });
            return;
        }

        if (!documentFileOther.current.files[0]) {
            error({
                title: "ERROR",
                text: "Document is required",
                modules: new Map([
                    [
                        Confirm,
                        {
                            confirm: true,
                            buttons: [
                                {
                                    text: "Ok",
                                    primary: true,
                                    click: (notice) => {
                                        notice.close();
                                    },
                                },
                            ],
                        },
                    ],
                ]),
            });
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("document_name", documentNameOther.current.value);
        formData.append("document_type", 'other');
        formData.append("candidate_id", props.params.id);

        if (documentFileOther.current.files[0]) {
            formData.append("document", documentFileOther.current.files[0]);
        }

        const token = getData();

        const headers = {
            "Contetnt-Type": "multipart/form-data",
            'Authorization': `Bearer ${token}`,
            'HC-User-Token': `Bearer ${token}`,
        }

        axios.post(process.env.REACT_APP_BASE_URL + "admin/hc_document_upload", formData, {
            headers: headers
        }).then((res) => {
            setLoading(false);
            if (res.status === 200) {
                _loadDocuments('other');
                success({
                    title: "SUCCESS",
                    text: res.message,
                    modules: new Map([
                        [
                            Confirm,
                            {
                                confirm: true,
                                buttons: [
                                    {
                                        text: "Ok",
                                        primary: true,
                                        click: (notice) => {
                                            notice.close();
                                        },
                                    },
                                ],
                            },
                        ],
                    ]),
                });
            } else {
                setLoading(false);
                error({
                    title: "ERROR",
                    text: res.message,
                    modules: new Map([
                        [
                            Confirm,
                            {
                                confirm: true,
                                buttons: [
                                    {
                                        text: "Ok",
                                        primary: true,
                                        click: (notice) => {
                                            notice.close();
                                        },
                                    },
                                ],
                            },
                        ],
                    ]),
                });
            }
        });
    };

    const uploadDocument = () => {
        if (!documentName.current.value) {
            error({
                title: "ERROR",
                text: "Document Name is required",
                modules: new Map([
                    [
                        Confirm,
                        {
                            confirm: true,
                            buttons: [
                                {
                                    text: "Ok",
                                    primary: true,
                                    click: (notice) => {
                                        notice.close();
                                    },
                                },
                            ],
                        },
                    ],
                ]),
            });
            return;
        }

        if (!documentFile.current.files[0]) {
            error({
                title: "ERROR",
                text: "Document is required",
                modules: new Map([
                    [
                        Confirm,
                        {
                            confirm: true,
                            buttons: [
                                {
                                    text: "Ok",
                                    primary: true,
                                    click: (notice) => {
                                        notice.close();
                                    },
                                },
                            ],
                        },
                    ],
                ]),
            });
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append("document_name", documentName.current.value);
        formData.append("document_type", 'signed');
        formData.append("candidate_id", props.params.id);

        if (documentFile.current.files[0]) {
            formData.append("document", documentFile.current.files[0]);
        }

        const token = getData();

        const headers = {
            "Contetnt-Type": "multipart/form-data",
            'Authorization': `Bearer ${token}`,
            'HC-User-Token': `Bearer ${token}`,
        }

        axios.post(process.env.REACT_APP_BASE_URL + "admin/hc_document_upload", formData, {
            headers: headers
        }).then((res) => {
            setLoading(false);
            if (res.status === 200) {
                _loadDocuments('signed');
                success({
                    title: "SUCCESS",
                    text: res.message,
                    modules: new Map([
                        [
                            Confirm,
                            {
                                confirm: true,
                                buttons: [
                                    {
                                        text: "Ok",
                                        primary: true,
                                        click: (notice) => {
                                            notice.close();
                                        },
                                    },
                                ],
                            },
                        ],
                    ]),
                });
            } else {
                setLoading(false);
                error({
                    title: "ERROR",
                    text: res.message,
                    modules: new Map([
                        [
                            Confirm,
                            {
                                confirm: true,
                                buttons: [
                                    {
                                        text: "Ok",
                                        primary: true,
                                        click: (notice) => {
                                            notice.close();
                                        },
                                    },
                                ],
                            },
                        ],
                    ]),
                });
            }
        });
    };

    const _delete = (id) => {
        confirmAlert({
            title: "Are you sure?",
            text: "You will not be able to recover this document!",
            confirm: true,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => _accept(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ],
        });
    }

    const _accept = (id) => {
        setLoading(true);
        deleteM("admin/hc_document_delete/" + id)
            .then(async function (response) {
                setLoading(false);
                if (response.status === 200) {
                    _loadDocuments('signed');
                    success({
                        title: "SUCCESS",
                        text: response.message,
                        modules: new Map([
                            [
                                Confirm,
                                {
                                    confirm: true,
                                    buttons: [
                                        {
                                            text: "Ok",
                                            primary: true,
                                            click: (notice) => {
                                                notice.close();
                                            },
                                        },
                                    ],
                                },
                            ],
                        ]),
                    });
                } else {
                    error({
                        title: "ERROR",
                        text: response.message,
                        modules: new Map([
                            [
                                Confirm,
                                {
                                    confirm: true,
                                    buttons: [
                                        {
                                            text: "Ok",
                                            primary: true,
                                            click: (notice) => {
                                                notice.close();
                                            },
                                        },
                                    ],
                                },
                            ],
                        ]),
                    });
                }
            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    }

    const _reject = (id) => {
        setDocumentId(id);
        window.$("#exampleModal").modal('show');
    };
    
    const _rejectDocument = () => {
        const reasonForRejection = document.getElementById('reasonForRejection').value;
        if (!reasonForRejection) {
            error({
                title: "ERROR",
                text: "Reason for rejection is required",
                modules: new Map([
                    [
                        Confirm,
                        {
                            confirm: true,
                            buttons: [
                                {
                                    text: "Ok",
                                    primary: true,
                                    click: (notice) => {
                                        notice.close();
                                    },
                                },
                            ],
                        },
                    ],
                ]),
            });
            return;
        }
        else {
            post("admin/hc_document/reject", { reason: reasonForRejection, document_id: documentId })
                .then(async function (response) {
                    window.$("#exampleModal").modal('hide');
                    setLoading(false);
                    if (response.status === 200) {
                        _loadDocuments('signed');
                        success({
                            title: "SUCCESS",
                            text: "Document rejected successfully",
                            modules: new Map([
                                [
                                    Confirm,
                                    {
                                        confirm: true,
                                        buttons: [
                                            {
                                                text: "Ok",
                                                primary: true,
                                                click: (notice) => {
                                                    notice.close();
                                                },
                                            },
                                        ],
                                    },
                                ],
                            ]),
                        });
                    } else {
                        error({
                            title: "ERROR",
                            text: "Something went wrong",
                            modules: new Map([
                                [
                                    Confirm,
                                    {
                                        confirm: true,
                                        buttons: [
                                            {
                                                text: "Ok",
                                                primary: true,
                                                click: (notice) => {
                                                    notice.close();
                                                },
                                            },
                                        ],
                                    },
                                ],
                            ]),
                        });
                    }
                })
                .catch(function (error) {
                    setLoading(false);
                    console.log(error);
                });
        }
    }

    function _sendMail() {
        setLoading(true);
        get("admin/hc_document_send_mail/" + props.params.id)
            .then(async function (response) {
                setLoading(false);
                if (response.status === 200) {
                    success({
                        title: "SUCCESS",
                        text: response.message,
                        modules: new Map([
                            [
                                Confirm,
                                {
                                    confirm: true,
                                    buttons: [
                                        {
                                            text: "Ok",
                                            primary: true,
                                            click: (notice) => {
                                                notice.close();
                                            },
                                        },
                                    ],
                                },
                            ],
                        ]),
                    });
                } else {
                    error({
                        title: "ERROR",
                        text: response.message,
                        modules: new Map([
                            [
                                Confirm,
                                {
                                    confirm: true,
                                    buttons: [
                                        {
                                            text: "Ok",
                                            primary: true,
                                            click: (notice) => {
                                                notice.close();
                                            },
                                        },
                                    ],
                                },
                            ],
                        ]),
                    });
                }
            })
            .catch(function (error) {
                setLoading(false);
                console.log(error);
            });
    }


    return (
        <>
            <Header />
            <Loader loading={loading} />

            <main>

                <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">Reject Document</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <textarea className="form-control" placeholder="Reason for rejection" id="reasonForRejection" style={{height: 200, width:'100%'}}></textarea>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary" onClick={() => _rejectDocument()}>Reject</button>
                        </div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid">
                    <div class="row">
                        {/* Menu Start */}
                        <SideBar />
                        {/*  Menu End */}

                        <div class="col">
                            <div class="page-title-container">
                                <div class="row g-0">
                                    <div class="col-sm-12 mb-2 mb-md-0 me-auto">
                                        <div class="w-auto">
                                            <h1 class="mb-0 pb-0 card-title" id="title">
                                                Hc Documents - {profile.candidate_first_name} {profile.candidate_last_name} <span className="text-muted" style={{fontSize:18}}>({profile.candidate_email})</span>
                                            </h1>
                                            <hr/>
                                        </div>

                                        <div className="mt-5 col-sm-12">
                                            <nav className="mt-5">
                                                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                                    <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Signed Documents</button>
                                                    <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Other Documents</button>
                                                </div>
                                            </nav>
                                            <div class="tab-content " id="nav-tabContent">
                                                <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                                    <div class="card border-bottom" style={{borderTopLeftRadius: 0,border:' 1px solid #dfdfdf',borderTop: 0,borderTopRightRadius: 0}}>
                                                        <div class="card-header d-flex justify-content-between">
                                                            <h5 class="card-title">Signed Documents</h5>
                                                        </div>
                                                        <div class="card-body">
                                                            <div className="row">
                                                                <div className="col-sm-5">
                                                                    <input type="text" className="form-control" placeholder="Document Name" id="documentName" ref={documentName}/>
                                                                </div>
                                                                <div className="col-sm-5">
                                                                    <input type="file" className="form-control" placeholder="Document" id="document" ref={documentFile}/>
                                                                </div>
                                                                <div className="col-sm-2">
                                                                    <button className="btn btn-primary" onClick={() => uploadDocument()}>Upload</button>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-5">
                                                                <div className="col-sm-12">
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Document Name</th>
                                                                                <th>Document Status</th>
                                                                                <th>Date</th>
                                                                                <th>Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody> 
                                                                            {
                                                                                documents.map((document, index) => (
                                                                                    <tr key={index}>
                                                                                        <td><a target="_blank" href={
                                                                                                        document.document_file_name.includes("amazonaws")
                                                                                                        ?
                                                                                                        document.document_file_name
                                                                                                        :
                                                                                                        process.env.REACT_APP_BASE_URL + "documents/" + document.document_file_name
                                                                                                    
                                                                                                    }>{document.document_name}</a></td>
                                                                                        <td>{document.document_status}</td>
                                                                                        <td>{document.createdAt}</td>
                                                                                        <td>
                                                                                            {
                                                                                                document.document_status != 'pending' && document.document_status != 'rejected' && (
                                                                                                    
                                                                                                    <a target="_blank" href={
                                                                                                        document.candidate_document_name.includes("amazonaws")
                                                                                                        ?
                                                                                                        document.candidate_document_name
                                                                                                        :
                                                                                                        process.env.REACT_APP_BASE_URL + "documents/" + document.candidate_document_name
                                                                                                    
                                                                                                    } className="btn btn-primary btn-sm me-1">View</a>
                                                                                                )
                                                                                            }

                                                                                            {
                                                                                                document.document_status != 'pending' && document.document_status != 'rejected' && (
                                                                                                    <button className="btn btn-secondary btn-sm me-1" onClick={() => _reject(document.id)}>Reject</button>
                                                                                                )
                                                                                            }
                                                                                            
                                                                                            <button className="btn btn-danger btn-sm" onClick={() => _delete(document.id)}>Delete</button>
                                                                                            
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                                                    <div class="card border-bottom" style={{borderTopLeftRadius: 0,border:' 1px solid #dfdfdf',borderTop: 0,borderTopRightRadius: 0}}>
                                                        <div class="card-body">
                                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                                <h5 class="card-title">Other Documents</h5>
                                                                <button className="btn btn-secondary" onClick={() => _sendMail()}>Send Mail</button>
                                                            </div>
                                                            
                                                            <div className="row">
                                                                <div className="col-sm-5">
                                                                    <input type="text" className="form-control" placeholder="Document Name" id="documentNameOther" ref={documentNameOther}/>
                                                                </div>
                                                                <div className="col-sm-5">
                                                                    <input type="file" className="form-control" placeholder="Document" id="documentOther" ref={documentFileOther}/>
                                                                </div>
                                                                <div className="col-sm-2">
                                                                    <button className="btn btn-primary" onClick={() => uploadDocumentOther()}>Upload</button>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-5">
                                                                <div className="col-sm-12">
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Document Name</th>
                                                                                <th>Date</th>
                                                                                <th>Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody> 
                                                                            {
                                                                                documentsOther.map((document, index) => (
                                                                                    <tr key={index}>
                                                                                        <td><a target="_blank" href={
                                                                                                        document.document_file_name.includes("amazonaws")
                                                                                                        ?
                                                                                                        document.document_file_name
                                                                                                        :
                                                                                                        process.env.REACT_APP_BASE_URL + "documents/" + document.document_file_name
                                                                                                    
                                                                                                    }>{document.document_name}</a></td>
                                                                                        <td>{document.createdAt}</td>
                                                                                        <td>
                                                                                            
                                                                                            
                                                                                            <button className="btn btn-danger btn-sm" onClick={() => _delete(document.id)}>Delete</button>
                                                                                            
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>


        </>
    );
}

export default withParams(HcDocuments);
